import { Alert, AlertTitle, Box, Container, Stack } from "@mui/material";
import React, { useState } from "react";
import Input from "../components/Base/Input";
import Header from "../components/common/Header";
import Note from "../components/common/Note";
import IntroCard from "../components/Cards/IntroCard";
import SubmitButton from "../components/common/SubmitButton";
import configData from "../Config";
import { useNavigate, useLocation } from "react-router-dom";
import Backdrop from "../components/common/Backdrop";
import LoadingDots from "../components/Lottie/LoadingDots";
import { apis } from "../services/apiService";
import "../Style/Theme/index.css";
import AlertPopup from "../components/common/AlertPopup";

export default function UploadGST() {
  const navigate = useNavigate();
  let location = useLocation();
  const [disabled, setDisabled] = useState(true);
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState();
  const [loading, setLoading] = useState(false);
  const [finalErr, setFinalErr] = useState("");
  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const reqData = {
        formfile: file,
        docno: fileName,
        filetype: "GSTCert",
        aid: location.state.AppId,
        // gst: location.state.gstin,
      };
      let resp = await apis.postWithFilesApi(
        configData.API_URL + "UploadDocument/UploadGSTCert",
        reqData
      );
      let result = await resp.json();
      if (resp?.status === 200) {
        let data = {
          AppId: location.state.AppId,
          anchor: location.state.anchor,
          program: location.state.program,
          source: location.state.source,
        };
        navigate("/property-details", { state: data });
      }
      setLoading(false);
    } catch (error) {
      const errorResult = JSON.parse(error?.message);
      setLoading(false);
      setFinalErr(errorResult?.statusMessage);
    }
  };
  const savefile = (e) => {
    if (e.target.files?.length > 0) {
      setFile(e.target.files[0]);
      setFileName(e.target.files[0].name);
      setDisabled(false);
    } else {
      setFile(undefined);
      setFileName(undefined);
      setDisabled(true);
    }
  };
  const handleClosedFunk = () => {
    setFinalErr("");
  };
  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header showBar={true} step={5} />
        <IntroCard
          title="Upload GST certificate"
          subtitle="Upload document to proceed"
          img="/assets/doc.svg"
        />
        <form onSubmit={handleSubmit}>
          <Box>
            <Input
              className=""
              type="file"
              onChange={savefile}
              autoComplete="off"
              name="gstCertificate1"
              id="gstCertificateId"
              accept=".zip,application/pdf"
            />
          </Box>
          <Box sx={{ paddingBottom: "50px" }}>
            <Note
              udyamNote="udyamNote"
              note="Only files with .pdf or .zip extension allowed"
            />
          </Box>
          {loading && (
            <Backdrop ax="center">
              <LoadingDots />
            </Backdrop>
          )}
          {finalErr && (
            <Backdrop ax="center">
              <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />
              ;
            </Backdrop>
          )}
          <SubmitButton hasNote="No" disabled={disabled} />
        </form>
      </Container>
    </>
  );
}
